import React from 'react';
import PusherProvider from 'utils/PusherProvider';
import BeepProvider from 'utils/BeepProvider';
import config from 'config';

const withPusher = (Element: React.ComponentType) => {
  if (config.IN_PRODUCTION) {
    return (
      <PusherProvider>
        <Element />
      </PusherProvider>
    );
  }

  return (
    <BeepProvider>
      <PusherProvider>
        <Element />
      </PusherProvider>
    </BeepProvider>
  );
};

export default withPusher;
